export interface SidebarItem {
  id: number;
  name: string;
  path?: string;
  claim?: string;
  lastSegment?: string;
  /** Bootstrap Icons class for the menu row, e.g. "bi bi-speedometer2". */
  icon?: string;
  subItems?: SidebarItem[];
}

export const ReportMenuData: SidebarItem[] = [
  {
    id: 0,
    name: "Dashboard",
    path: "dashboard",
    icon: "bi bi-speedometer2"
  },
  {
    id: 1,
    name: "Transaction Reports",
    icon: "bi bi-arrow-left-right",
    subItems: [
      {
        id:1,
        name: "Gift Card Transaction Detail",
        path: "giftcardtransactiondetail",
        claim: "ViewGiftCardTransactionDetail",
        lastSegment: "giftcardtransactiondetail"
      },
      {
        id: 5,
        name: "Monthly Declined Transactions",
        path: "monthlydeclinedtransactions",
        claim: "ViewMonthlyDeclinedTransactions",
        lastSegment: "monthlydeclinedtransactions",
      },
      {
        id:10,
        name: "Program Summary",
        path: "programsummarydetail",
        claim: "ViewProgramSummary",
        lastSegment: "programsummarydetail",
      },
      {
        id:20,
        name: "Transaction Summary",
        path: "transactionsummary",
        claim: "ViewTransactionSummary",
        lastSegment: "transactionsummary",
      },
    ],
  },
  {
    id:2,
     name: "Financial Reports",
    icon: "bi bi-cash-stack",
    subItems: [
      {
        id: 1,
        name: "Card Defunding Transaction Detail",
        path: "carddefundingtransactiondetail",
        claim: "ViewCardDefundingTransactionDetail",
        lastSegment: "carddefundingtransactiondetail",
      },
    ],  
  },
  {
    id:3,
    name: "Merchant Reports",
    icon: "bi bi-shop",
        subItems: [
          {
            id:1,
            name: "Merchant Transaction Detail - Authorizations Only",
            path: "merchanttransactiondetail/authorizations",
            claim: "ViewMerchantAuthorizationTransactionDetail",
            lastSegment: "authorizations",
          },          
          {
            id:10,
            name: "Merchant Transaction Detail - Settlements Only",
            path: "merchanttransactiondetail/settlements",
            claim: "ViewMerchantSettlementTransactionDetail",
            lastSegment: "settlements",
          }

        ],
  },
  {
    id: 4,
     name: "Red Reports",
    icon: "bi bi-flag",
        subItems: [
          {
            id: 1,
            name: "Card Adjustment",
            path: "cardadjustment",
            claim: "ViewCardAdjustment",
            lastSegment: "cardadjustment",
          },
          {
            id:2,
            name: "Cardholder Fee Summary",
            path: "cardholderfeesummary",
            claim: "ViewCardholderFeeSummary",
            lastSegment: "cardholderfeesummary",
          },
          {
            id:3,
            name: "Cardholder Liability",
            path: "cardholderliability",
            claim: "ViewCardholderLiability",
            lastSegment: "cardholderliability",
          },


          {
            id: 6,
            name: "Cross-Bin Transfer Summary",
            path: "crossbintransfersummary",
            claim: "ViewCrossBinTransferSummary",
            lastSegment: "crossbintransfersummary",
          },
          {
            id: 7,
            name: "Declined Authorization Request",
            path: "declinedauthorizationrequest",
            claim: "ViewDeclinedAuthorizationRequest",
            lastSegment: "declinedauthorizationrequest",
          },

          {
            id: 9,
            name: "Mastercard Interchange Income Summary",
            path: "mastercardinterchangeincomesummary",
            claim: "ViewMastercardInterchangeIncomeSummary",
            lastSegment: "mastercardinterchangeincomesummary",
          },
          {
            id:10,
            name: "MasterCard Settlement Reconciliation",
            path: "mastercardsettlementreconciliation",
            claim: "ViewMasterCardSettlementReconciliation",
            lastSegment: "mastercardsettlementreconciliation",
          },
          {
            id:20,
            name: "Mastercard Fee Summary",
            path: "mastercardfeesummary",
            claim: "ViewMasterCardFeeSummary",
            lastSegment: "mastercardfeesummary",
          },
          {
            id:30,
            name: "Pulse Settlement Reconciliation",
            path: "pulsesettlementreconciliation",
            claim: "ViewPulseSettlementReconciliation",
            lastSegment: "pulsesettlementreconciliation",
          }, 
          
          {
            id:40,
            name: "Trial Balance Historical Data",
            path: "trialbalancehistoricaldata",
            claim: "ViewTrialBalanceHistoricalData",
            lastSegment: "trialbalancehistoricaldata",
          },    
          {
            id:50,
            name: "Visa Settlement Reconciliation",
            path: "visasettlementreconciliation",
            claim: "ViewVisaSettlementReconciliation",
            lastSegment: "visasettlementreconciliation",
          }
        ],
    },
];
